/** ***********
*
* <certificate.reducer.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  pranshushrivastav [pranshu.shrivastav@soprasteria.com]
*
* All rights reserved.
**************/

import { Certificate } from 'src/app/models/certificate';
import {
    errorAcceptCertificateRequest,
    errorCancelCertificateDeletion,
    errorCreateCertificateRequest,
    errorDeleteCertificateRequest,
    errorFetchCertificate,
    errorRefuseCertificateRequest,
    errorReinstallCertificate,
    errorRenewCertificateRequest,
    errorUpdateCertificateRequest,
    fetchCertificate,
    successAcceptCertificateRequest,
    successCancelCertificateDeletion,
    successCreateCertificateRequest,
    successDeleteCertificateRequest,
    successFetchCertificate,
    successRefuseCertificateRequest,
    successReinstallCertificate,
    successRenewCertificateRequest,
    successUpdateCertificateRequest
} from '../actions/certificate.action';

import { Action, createReducer, on } from '@ngrx/store';
export interface State {
    data: Certificate[];
    loading: boolean;
    loaded: boolean;
}

// default state
const INIT_STATE: State = {
    data: [],
    loading: false,
    loaded: false,
};

const certificateReducer = createReducer(
    INIT_STATE,
    on(fetchCertificate, (state): State => ({
        ...state, loading: true,
    })),
    on(successFetchCertificate, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            state.data = payload;
            return state.data;
        })()
    })),
    on(successCreateCertificateRequest, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            state.data.push(...payload);
            return [...state.data];
        })()
    })),
    on(successUpdateCertificateRequest, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            const datas = [...state.data];
            const arrayCertificateToUpdate = payload;
            for (const certificate of arrayCertificateToUpdate) {
                const certificateIndex = datas.findIndex(_certificate => _certificate.id === certificate.id);
                if (certificateIndex > -1) {
                    datas[certificateIndex] = certificate;
                }
            }
            return datas;
        })()
    })),
    on(successDeleteCertificateRequest, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            const allCertificate = [...state.data];
            const arrayCertificateToDelete = payload;
            for (const certificate of arrayCertificateToDelete) {
                const individualCertificate = allCertificate.find(_certificate => _certificate.id === certificate.id);
                Object.assign(individualCertificate, certificate);
            }
            return allCertificate;
        })()
    })),
    on(successRenewCertificateRequest, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            for (const certificate of payload) {
                state.data.splice(
                    state.data.findIndex(e => e.id === certificate.id), 1, certificate);
            }
            return [...state.data];
        })()
    })),
    on(successAcceptCertificateRequest, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            for (const certificate of payload) {
                state.data.splice(
                    state.data.findIndex(e => e.id === certificate.id), 1, certificate);
            }
            return [...state.data];
        })()
    })),
    on(successRefuseCertificateRequest, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            for (const certificate of payload) {
                state.data.splice(
                    state.data.findIndex(e => e.id === certificate.id), 1, certificate);
            }
            return [...state.data];
        })()
    })),
    on(successCancelCertificateDeletion, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            state.data.splice(
                state.data.findIndex(e => e.id === payload.id), 1, payload);
            return [...state.data];
        })()
    })),
    on(successReinstallCertificate, (state, { payload }) => ({
        ...state,
        loading: false,
        loaded: true,
        data: (() => {
            state.data.splice(
                state.data.findIndex(e => e.id === payload.id), 1, payload);
            return [...state.data];
        })()
    })),
    on(errorAcceptCertificateRequest,
        errorCancelCertificateDeletion,
        errorCreateCertificateRequest,
        errorDeleteCertificateRequest,
        errorFetchCertificate,
        errorRefuseCertificateRequest,
        errorReinstallCertificate,
        errorRenewCertificateRequest,
        errorUpdateCertificateRequest, (state): State => ({
            ...state, loading: false,
        })),
);

export function reducer(state: State | undefined, action: Action) {
    return certificateReducer(state, action);
}
